export const authHeader = (token) => `Basic ${token}`;

export const resolveUrl = (url, get) =>
  url
    .replace('{{backendUrl}}', get('backend.url'))
    .replace('{{yappersUrl}}', get('backend.yappersUrl'))
    .replace('{{certificationUrl}}', get('backend.taskUrl'))
    .replace('{{taskUrl}}', get('backend.taskUrl'));

export const prepareConfig = (get, set, conf, idSite) => {
  const taskUrl =
    idSite !== '10' && idSite !== '22' ? get('backend.yappersUrl') : get('backend.url');
  set(conf, 'backend.taskUrl', taskUrl);
};
